export default __webpack_public_path__ + "static/media/ISKO CLASS 9 SYLLABUS.30aeff24.pdf";